import { HostListener, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  HttpClient,
  HttpErrorResponse,
  HttpRequest,
  HttpHandler,
  HttpResponse,
  HttpEvent,
  HttpHeaders,
} from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { map, tap, finalize } from 'rxjs/operators';
import { environment } from './../../../../../environments/environment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { isPlatformBrowser } from '@angular/common';
import * as FileSaver from 'file-saver';

import {
  SnackBarMessage,
} from './../../../models/index';
// import { CookieService } from 'ngx-cookie-service';
// import { CommonService } from '../common/common.service';
// import { routes } from '../../loader-less-routes/routes';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  horizontalPosition: MatSnackBarHorizontalPosition = 'start';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';
  rfqData(arg0: { limit: number; offset: number }) {
    throw new Error('Method not implemented.');
  }
  SERVER_URL = environment.SERVER_URL;
  sideBarHeight: number = 0;
  page: any;
  profile: any;
  isLoading: any;
  storeItemVal: any
  otpSubject = new Subject();

  constructor(
    private loader: NgxUiLoaderService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private _snackBar: MatSnackBar,
    // private cookieService: CookieService,
    // private commonService: CommonService,
    @Inject(PLATFORM_ID) private platform: Object
  ) {
    // window.addEventListener("beforeunload", function (e) {
    //   console.log("jssjjs");
    //   commonService.logout()

    // });
    // alert(env.production)
  }

  objToQueryString(obj: any): string {
    if (!obj) {
      return '';
    }

    const searchParams = new URLSearchParams();
    const params = obj;
    Object.keys(params).forEach((key) => searchParams.append(key, params[key]));

    return searchParams.toString();
  }

  isRequestFromBrowser() {
    if (!isPlatformBrowser(this.platform)) {
      // Need for SSR setup
      return false;
    } else {
      return true;
    }
  }

  getToken() {
    if (!this.isRequestFromBrowser()) {
      // Need for SSR setup
      return null;
    }

    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'yes'
    ) {
      return localStorage.getItem('token');
    }
    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'no'
    ) {
      return sessionStorage.getItem('token');
    } else {
      return null;
    }
  }

  // intercept(
  //   request: HttpRequest<any>,
  //   next: HttpHandler
  // ): Observable<HttpEvent<any>> {
  //   const started = Date.now();

  //   const headers = {
  //     session_id: this.getCookie('_session'),
  //   };

  //   let ok: any;
  //   const token = this.getToken();

  //   if (token) {
  //     // make sure token is coming,
  //     request = request.clone({
  //       setHeaders: {
  //         Authorization: `Bearer ${token}`,
  //         ...headers,
  //       },
  //     });
  //   } else {
  //     request = request.clone({
  //       setHeaders: headers,
  //     });
  //   }

  //   return next.handle(request).pipe(
  //     tap(
  //       // Succeeds when there is a response; ignore other events
  //       (event) => (ok = event instanceof HttpResponse ? 'succeeded' : ''),
  //       // Operation failed; error is an HttpErrorResponse
  //       (error) => (ok = error)
  //     ),
  //     // Log when response observable either completes or errors
  //     finalize(() => {
  //       this.loader.stop();
  //       const elapsed = Date.now() - started;
  //       if (ok == 'succeeded') {
  //         const msg = `${request.method} "${request.urlWithParams}"

  //          ${ok} in ${elapsed} ms.`;
  //         //  For make sure how much time consumed
  //         // console.log(msg);
  //       } else {
  //         console.log(ok);
  //         console.log('request: ', request);
  //         if (ok['status'] == 401) {
  //           // logout from here
  //           this.router.navigate(['/']);
  //           console.log(ok['status']);
  //         } else {
  //           if (request.url.search('users/bulkUploadProducts') == -1) {
  //             this.handleError(ok);
  //           }
  //         }
  //       }
  //     })
  //   );
  // }

  isAuthenticated() {
    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'yes'
    ) {
      return localStorage.getItem('isLogged') == 'true';
    }
    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'no'
    ) {
      return localStorage.getItem('isLogged') == 'true';
    } else {
      return false;
    }
  }

  // setCookies(obj: AddCookie): void {
  //this.cookieService.set(obj.key, obj.value, obj.expires);
  //  }

  getCookie(key: string): string {
    return ""
    //return this.cookieService.get(key);
  }

  deleteCookie(key: string): void {
    //this.cookieService.delete(key);
  }

  loggedUserDetails() {
    if (!this.isRequestFromBrowser()) {
      // Need for SSR setup
      return null;
    }

    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'yes'
    ) {
      return JSON.parse(localStorage.getItem('user_details') || '{}');
    }
    if (localStorage.getItem('remember_me')) {
      return JSON.parse(sessionStorage.getItem('user_details') || '{}');
    } else {
      return null;
    }
  }

  setLoggedUserDetails(object: any) {
    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'yes'
    ) {
      localStorage.setItem('user_details', JSON.stringify(object));
    }
    if (localStorage.getItem('remember_me')) {
      sessionStorage.setItem('user_details', JSON.stringify(object));
    } else {
    }
  }

  setDataInLocalStorage(
    key: any,
    value: any,
    isObjectOrArray: boolean = false
  ) {
    if (isObjectOrArray) localStorage.setItem(key, value);

    if (isObjectOrArray) localStorage.setItem(key, JSON.stringify(value));

    return true;
  }

  getDataFromLocalStorage(key: any, isObjectOrArray: boolean = false): any {
    if (!localStorage.getItem(key)) return '';

    if (isObjectOrArray) return JSON.parse(localStorage.getItem(key) || '{}');

    return localStorage.getItem(key);
  }

  addBodyClass() {
    const bodyTag = document.body;
    bodyTag.classList.add('my-class');
  }
  removeBodyClass() {
    const bodyTag = document.body;
    bodyTag.classList.remove('my-class');
  }

  // showSuccessMessage(object: SnackBarMessage) {
  //   // this.addBodyClass()
  //   let snackBarRef = this._snackBar.open(
  //     object.message,
  //     object.action ? object.action : 'CLOSE',
  //     {
  //       duration: 3000,
  //       verticalPosition: 'bottom',
  //       horizontalPosition: 'center',
  //       panelClass: ['my_snackbar'],
  //     }

  //   );
  //   // snackBarRef.afterDismissed().subscribe(() => {
  //   //  this.removeBodyClass();
  //   // // window.location.reload();

  //   // });
  // }
  // showSuccessMessageenquiry(object: SnackBarMessage) {
  //   // this.addBodyClass()
  //   let snackBarRef = this._snackBar.open(
  //     object.message,
  //     object.action ? object.action : 'CLOSE',
  //     {
  //       duration: 3000,
  //       verticalPosition: 'bottom',
  //       horizontalPosition: 'center',
  //       panelClass: ['my_snackbar'],
  //     }

  //   );
  //   snackBarRef.afterDismissed().subscribe(() => {
  //   //  this.removeBodyClass();
  //    window.location.reload();

  //   });
  // }


  showSuccessMessage(object: SnackBarMessage) {
    // this.addBodyClass()
    let snackBarRef = this._snackBar.open(
      object.message,
      object.action ? object.action : 'CLOSE',
      {
        duration: 3000,
        verticalPosition: 'bottom',
        horizontalPosition: 'center',
        panelClass: ['my_snackbar'],
      }

    );
    // snackBarRef.afterDismissed().subscribe(() => {
    //  this.removeBodyClass()
    // });
  }

  showSuccessMessageenquiry(object: SnackBarMessage) {
    // this.addBodyClass()
    let snackBarRef = this._snackBar.open(
      object.message,
      object.action ? object.action : 'CLOSE',
      {
        duration: 3000,
        verticalPosition: 'bottom',
        horizontalPosition: 'center',
        panelClass: ['my_snackbar'],
      }

    );
    snackBarRef.afterDismissed().subscribe(() => {
      //  this.removeBodyClass();
      window.location.reload();

    });
  }
  showErrorMessage(object: SnackBarMessage) {
    this.addBodyClass()
    let snackBarRef = this._snackBar.open(
      object.message,
      object.action ? object.action : 'CLOSE',

      {

        duration: undefined,
        verticalPosition: 'bottom',
        horizontalPosition: 'center',
        panelClass: ['my_snackbar'],
      }

    );
    // snackBarRef.afterDismissed().subscribe(() => {
    //   this.removeBodyClass()
    // });
  }



  updateLoginDetails(details: any) {
    // whenever talent/talent edit name and name will reflect

    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'yes'
    ) {
      return localStorage.setItem('admin_details', JSON.stringify(details));
    }
    if (localStorage.getItem('remember_me')) {
      return sessionStorage.setItem('admin_details', JSON.stringify(details));
    }
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error && error.error.errors) {
      // client-side error and server side
      if (Array.isArray(error.error.errors.msg)) {
        // validation error message

        if (error.error.errors.msg.length) {
          console.log(error.error.errors.msg, "(error.error.errors.msg");

          const ob = error.error.errors.msg[0];
          if (ob.msg == 'IS_EMPTY') {
            errorMessage = `${ob.param} missing`;
          } else {
            errorMessage = ob.msg;
          }
        }
      } else {
        errorMessage = error.error.errors.msg;
      }
    } else {
      // server-side error
      if (error.status == 401) {
        // Unauthorised
        // this.commonService.logout();
        this.router.navigate(['/']);
      }

      console.log(error);
      if (navigator.onLine == false) {
        errorMessage = `Please check your internet connection!`;
      }
      else {

        errorMessage = `Something went wrong here`;
      }
      // errorMessage = `${error.message}`;
    }
    console.log('I am here ', errorMessage);
    // if (this.bulkUpload(error)) {
    //   return;
    // }
    this.showErrorMessage({
      message: errorMessage,
    });
    return throwError(errorMessage);
  }

  //login
  getsubject(): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getSubject`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }
  getlanguage(): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getLanguage`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }
  getschool(obj: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getSchool?search=${obj}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }
  checkzip(obj: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/checkpincode`;
    return this.http.post(API_URL, obj).pipe(
      map((res) => {
        return res;
      })
    );
  }
  login(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}teacher/login`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  instituteLogin(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}institute/login`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  schoologin(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}school/login`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  registerSchool(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}register/school`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }
  register(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}register`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  registerupdate(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}updateRegistertion`;
    return this.http.patch(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }
  registerupdateschool(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}updateSchoolLogin`;
    return this.http.patch(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }


  payment(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}payment/payumoney`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }


  resetPassword(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}reset/password`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  checkResetPassword(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}check-forgot-password-link`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  resetPasswordschool(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}reset/school/password`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  storeItem(storeItem: any) {
    this.storeItemVal = storeItem;
    // console.log(storeItem,"storeitem");

  }

  details() {
    return this.storeItemVal
  }

  postal_api(data: string): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/check/pincode?pincode=${data}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  school_email_api(data: string): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/check/email?email=${data}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }
  getpaymewntdata(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getStudent/By-payment_id?payment_id=${data.payment_id}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }





  forgot(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}forgotPassword`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }
  forgotSchool(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}school/forgotPassword`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  change_PasswordForSchool(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}change/password/school`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }
  change_Password(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}change/password`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }
  sendquery(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/contact/queries`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getaboutMtse(): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getAboutExam`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }


  signupHistory(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/save/history-log`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  contactUs(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/createContactUs`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  successPayment(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}payment/success?payment_id=${data.payment_id}`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  addTempUser(data: any, session_id: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}add-temp/user`;
    const header = new HttpHeaders({ 'Content-Type': 'application/json', 'session_id': session_id });
    return this.http.post(API_URL, data, { headers: header }).pipe(
      map((res) => {
        return res;
      })
    );
  }

  addTempSchool(data: any, session_id: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}add-temp/school`;
    const header = new HttpHeaders({ 'Content-Type': 'application/json', 'session_id': session_id });
    return this.http.post(API_URL, data, { headers: header }).pipe(
      map((res) => {
        return res;
      })
    );
  }
  registrationForm(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}register`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }
  registerInstitute(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}register-institute`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }
  
  studentExamForm(data:any){
    const API_URL = `${this.SERVER_URL}users/studentExamForm`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  registrationSchoolForm(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}register/school`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getAnnouncement(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/get/announcement-info?limit=${data.limit}&offset=${data.offset}&type=${data.type}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getEnquiryType(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getEnquiryManagementList?filter=${data.filter}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getPaidSubject(): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getPaidSubject`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getSubjectByStudent(): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getSubjectByStudent`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }


  subjectPayment(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}after-reg/subject-payment`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getHomePageByID(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getHomePageByID?id=${data.id}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  // generateInvoice(data:any): Observable<any> {
  //   const API_URL = `${this.SERVER_URL}users/generateInvoice?id=${data.id}`;
  //     return this.http.get(API_URL).pipe(
  //       map((res) => {
  //         return res;
  //       })
  //     );
  //   }
  generateInvoice(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}generateInvoice`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }
  getpayhistorylog(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/get/pay-history-log?user_id=${data.user_id}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getPaymentHistoryBySchool(data: any): Observable<any> {
    const query = this.objToQueryString(data);

    const API_URL = `${this.SERVER_URL}users/getPaymentHistoryBySchool?${query}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getPaymentHistoryBySchoolDetails(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/get/pay-history-log/school-student?id=${data.user_id}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getUserById(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getUserById?id=${data.id}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }



  csvDownload(headers: any, data: any) {
    console.log("data:", data);

    if (!data || !data.length) {
      return;
    }

    const separator = ',';
    const csvContent = headers.join(separator) + '\n' + data.map((rowData: any) => {
      return headers.map((headkey: any) => {
        const property = headkey.toLowerCase().replace(/\s+/g, '_');
        let value = rowData[property] ? rowData[property] : '';

        // Convert the value to a string before checking for a comma
        value = value ? String(value) : '';

        // Check if the value contains a comma, if so, enclose it in double quotes
        if (value.includes(',')) {
          value = '"' + value + '"';
        }

        return value;
      }).join(separator);
    }).join('\n');

    this.exportFile(csvContent, 'text/csv');
  }

  exportFile(data: any, fileType: string) {
    console.log('csvData:', data);

    const blob = new Blob([data], { type: fileType });
    FileSaver.saveAs(blob, 'Downloaded CSV')
  }


  getUserFromB2C(data: any): Observable<any> {
    const query = this.objToQueryString(data);

    const API_URL = `${this.SERVER_URL}users/getUserFromB2C?${query}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getSchoolDashBoard(): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getSchoolDashBoard`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getStudentRegisterSchoolInMonth(data: any): Observable<any> {
    const query = this.objToQueryString(data);
    const API_URL = `${this.SERVER_URL}users/getStudentRegisterSchoolInMonth?${query}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }


  getUsergradeWiseChart(): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getUsergradeWiseChart`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  sentOtp(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/sendOtp`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  verfifyOtp(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/verify/OTP`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getReceiptId(): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/get/receipt_id`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  generateOrderOfStudent(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}generateOrderOfStudent`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  generateOfflineInvoice(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/generateOfflineInvoice`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getSchoolReceipt(data: any): Observable<any> {
    const query = this.objToQueryString(data);
    const API_URL = `${this.SERVER_URL}users/getReceiptBySchool?${query}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  updateStudentData(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/updateStudentBySchool`;
    return this.http.patch(API_URL, data)
      .pipe(
        map(res => {
          return res;
        }),
      );
  }

  deleteStudentData(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/deleteStudentById/${data.id}`;
    return this.http.delete(API_URL)
      .pipe(
        map(res => {
          return res;
        }),
      );
  }
  
  admitCardDownloaded(): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/admitCardDownloaded`;
    return this.http.patch(API_URL, null)
      .pipe(
        map(res => {
          return res;
        }),
      );
  }

  loginWithOTP(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}student/login`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  loginWithPassword(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}login`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  forgotPassword(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}forgotPassword`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

}



